import {
  Copyright,
  ThirdPartyNotices,
} from "@web-applications/allinga-web-components";
import SSML from "features/SSML";
import TTSHomepage from "features/TTS";
import { Navigate, Route, Routes } from "react-router-dom";
import BrowserDisclaimer from "shared/components/BrowserDisclaimer";
import { RELEASE_NOTES_URL } from "shared/constants";
import { PATHS } from "shared/constants/paths";
import MarkdownRenderer from "shared/containers/MarkdownRenderer";
import Navbar from "shared/containers/Navbar";
import CheatSheet from "../SSML/CheatSheet";

export default function AppRoutesOnPrem(): JSX.Element {
  return (
    <>
      <Navbar />
      <BrowserDisclaimer />
      <Routes>
        <Route path={PATHS.root} element={<TTSHomepage />} />
        <Route
          path={PATHS.releaseNotes}
          element={<MarkdownRenderer url={RELEASE_NOTES_URL} />}
        />
        <Route path={PATHS.ssmlGuide} element={<SSML />} />
        <Route path={PATHS.ssmlCheatSheet} element={<CheatSheet />} />
        <Route path={PATHS.thirdPartyNotices} element={<ThirdPartyNotices />} />
        <Route path={PATHS.copyright} element={<Copyright />} />

        {/* Redirect any URL to root */}
        <Route path="*" element={<Navigate to={PATHS.root} />} />
      </Routes>
    </>
  );
}
